import * as React from "react"
const ExcelFileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={40}
    fill="none"
    {...props}
  >
    <path
      stroke="#1CA660"
      strokeWidth={2}
      d="m1.595 10.357 8.898-8.78A2 2 0 0 1 11.898 1H28a3 3 0 0 1 3 3v32a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V11.78a2 2 0 0 1 .595-1.423Z"
    />
    <path stroke="#1CA660" strokeWidth={2} d="M11 2v9a1 1 0 0 1-1 1H2" />
    <path
      fill="#1CA660"
      d="M22 31h-3.11l-2.987-4.539L12.916 31H10l4.26-6.189L10.273 19h3.005l2.767 4.317L18.758 19h2.934l-4.032 5.95L22 31Z"
    />
  </svg>
)
export default ExcelFileIcon